import { FormBean } from "../../datatypes";

export function navigate(formBean:FormBean, viewName:string, viewNames:string[], changeWhenError?:any){
    let viewIndex = viewNames.indexOf(viewName);
    if (viewIndex != -1){
        if(!formBean.hasError || changeWhenError){
            formBean.changeView!(viewName);
        }
    }
}


function cancel(formBean:FormBean, viewName:string, viewNames:string[]){
    let newIndex = viewNames.indexOf(viewName);
    if (newIndex != -1){
        formBean.changeView!(viewName, undefined, undefined, true);
    }
}


function nextView(formBean:FormBean, viewNames:string[]){
    let viewName = formBean.CurrentViewName;
    let newIndex = viewNames.indexOf(formBean.CurrentViewName) + 1;

    if(newIndex < viewNames.length) {
        viewName = viewNames[newIndex];

        if(!formBean.hasError){
            formBean.changeView!(viewName);
        }
    }
}

function previousView(formBean:FormBean, viewNames:string[]){
    let viewName = formBean.CurrentViewName;

    let newIndex = viewNames.indexOf(formBean.CurrentViewName) - 1;
    if(newIndex >= 0) {
        viewName = viewNames[newIndex];
        formBean.changeView!(viewName);
    }
}

function firstView(formBean:FormBean, viewNames:string[]){
    let newIndex = 0;
    let viewName = viewNames[newIndex];
  
    formBean.changeView!(viewName);
}

export const UIFlowEventHandlerTypeA = {} as {[key:string]:typeof navigate}
export const UIFlowEventHandlerTypeB = {} as {[key:string]:typeof firstView}

UIFlowEventHandlerTypeA.navigate = navigate;
UIFlowEventHandlerTypeA.cancel = cancel;

UIFlowEventHandlerTypeB.nextView = nextView;
UIFlowEventHandlerTypeB.previousView = previousView;
UIFlowEventHandlerTypeB.firstView = firstView;
